/**
 * It takes a token, fileName, and fileType and returns a presigned URL to upload a file to S3.
 * @param token - the token that you get from the login API
 * @param fileName - The name of the file you want to upload.
 * @param fileType - "image/jpeg"
 * @returns The presignedURL is being returned.
 */
import axios from "axios";
export const presignedURL = async (token, fileName, fileType) => {
  var config = {
    method: "post",
    url: process.env.REACT_APP_LBDA+"postUploadURL",
    headers: {
      Authorization: `Bearer ${token} `,
    },
    data: { name: fileName, content_Type: fileType },
  };
  try {
    const response = await axios(config)
      .then(function (response) {
        return response.data.uploadURL;
      })
      .catch(function (error) {
        return false;
      });
    return response;
  } catch (error) {
    return false;
  }
};
